import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "navbar navbar-expand-lg fixed-top navbar-dark bg-dark",
  style: {"margin-bottom":"0"},
  "data-testid": "corporate-nav"
}
const _hoisted_2 = {
  class: "collapse navbar-collapse",
  id: "navBar"
}
const _hoisted_3 = { class: "navbar-nav mr-auto" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = {
  class: "navbar-brand",
  "data-testid": "corporate-nav-portfolios"
}
const _hoisted_6 = { class: "nav-item dropdown" }
const _hoisted_7 = { class: "dropdown-menu" }
const _hoisted_8 = {
  class: "dropdown-item",
  "data-testid": "corporate-nav-projects-proposals"
}
const _hoisted_9 = {
  class: "dropdown-item",
  "data-testid": "corporate-nav-projects-scheduled"
}
const _hoisted_10 = {
  class: "dropdown-item",
  "data-testid": "corporate-nav-projects-started"
}
const _hoisted_11 = {
  class: "dropdown-item",
  "data-testid": "corporate-nav-projects-finished"
}
const _hoisted_12 = {
  class: "dropdown-item",
  "data-testid": "corporate-nav-projects-all"
}
const _hoisted_13 = { class: "nav-item dropdown" }
const _hoisted_14 = { class: "dropdown-menu" }
const _hoisted_15 = {
  class: "dropdown-item",
  "data-testid": "corporate-nav-manage-settings"
}
const _hoisted_16 = {
  class: "dropdown-item",
  "data-testid": "corporate-nav-manage-attributes"
}
const _hoisted_17 = {
  class: "dropdown-item",
  "data-testid": "corporate-nav-manage-resources"
}
const _hoisted_18 = {
  class: "dropdown-item",
  "data-testid": "corporate-nav-manage-revenues"
}
const _hoisted_19 = {
  class: "dropdown-item",
  "data-testid": "corporate-nav-manage-costs"
}
const _hoisted_20 = {
  class: "dropdown-item",
  "data-testid": "corporate-nav-manage-capex"
}
const _hoisted_21 = {
  class: "dropdown-item",
  "data-testid": "corporate-nav-manage-pnls"
}
const _hoisted_22 = { class: "nav-item dropdown" }
const _hoisted_23 = { class: "dropdown-menu" }
const _hoisted_24 = {
  class: "dropdown-item",
  "data-testid": "corporate-nav-business-case-templates"
}
const _hoisted_25 = {
  class: "dropdown-item",
  "data-testid": "corporate-nav-business-case-metrics"
}
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = {
  class: "nav-link",
  "data-testid": "corporate-nav-planning"
}
const _hoisted_28 = { class: "navbar-nav" }
const _hoisted_29 = { class: "nav-item dropdown" }
const _hoisted_30 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_31 = {
  class: "dropdown-item",
  "data-testid": "corporate-nav-account-workspace"
}
const _hoisted_32 = {
  class: "dropdown-item",
  "data-testid": "corporate-nav-account-manage"
}
const _hoisted_33 = {
  class: "dropdown-item",
  "data-testid": "corporate-nav-account-sign-out"
}

import { computed } from 'vue';
    import { useRoute } from 'vue-router';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CorporateNavigation',
  props: {
    ActivePage: {},
    propStrategyId: {}
  },
  setup(__props: any) {

    const props = __props;

    const route = useRoute();

    const workspaceId = computed(() => Number(route.params?.workspaceId ?? 0));
    const strategyId = computed(() => route.params?.strategyId ?? props.propStrategyId);

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _cache[28] || (_cache[28] = _createElementVNode("button", {
      class: "navbar-toggler",
      type: "button",
      "data-toggle": "collapse",
      "data-target": "#navBar",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation",
      "data-testid": "corporate-nav-toggle"
    }, [
      _createElementVNode("span", { class: "navbar-toggler-icon" })
    ], -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Portfolios ", -1 /* CACHED */)
          ]))])), [
            [_directive_sanitizedHref, `/#/strategy/portfolios/${workspaceId.value}/${strategyId.value}`]
          ])
        ]),
        _createElementVNode("li", _hoisted_6, [
          _cache[7] || (_cache[7] = _createElementVNode("a", {
            class: "nav-link dropdown-toggle",
            "data-toggle": "dropdown",
            "data-testid": "corporate-nav-projects"
          }, " Projects ", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_8, [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Proposals", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/enterprise/projects/proposals/${workspaceId.value}/${strategyId.value}`]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_9, [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Scheduled", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/enterprise/projects/scheduled/${workspaceId.value}/${strategyId.value}`]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_10, [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Started", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/enterprise/projects/started/${workspaceId.value}/${strategyId.value}`]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_11, [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Finished", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/enterprise/projects/finished/${workspaceId.value}/${strategyId.value}`]
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_12, [...(_cache[5] || (_cache[5] = [
              _createTextVNode("All", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/enterprise/projects/all/${workspaceId.value}/${strategyId.value}`]
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_13, [
          _cache[17] || (_cache[17] = _createElementVNode("a", {
            class: "nav-link dropdown-toggle",
            "data-toggle": "dropdown",
            "data-testid": "corporate-nav-manage"
          }, " Manage ", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_15, [...(_cache[8] || (_cache[8] = [
              _createTextVNode("Settings", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/enterprise/settings/${workspaceId.value}/${strategyId.value}`]
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_16, [...(_cache[9] || (_cache[9] = [
              _createTextVNode("Attributes", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/enterprise/attributes/${workspaceId.value}/${strategyId.value}`]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_17, [...(_cache[10] || (_cache[10] = [
              _createTextVNode("Resources", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/enterprise/resources/${workspaceId.value}/${strategyId.value}`]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_18, [...(_cache[11] || (_cache[11] = [
              _createTextVNode("Revenues", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/enterprise/revenues/${workspaceId.value}/${strategyId.value}`]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_19, [...(_cache[12] || (_cache[12] = [
              _createTextVNode("Costs", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/enterprise/costs/${workspaceId.value}/${strategyId.value}`]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_20, [...(_cache[13] || (_cache[13] = [
              _createTextVNode("CAPEX", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/enterprise/capex/${workspaceId.value}/${strategyId.value}`]
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_21, [...(_cache[14] || (_cache[14] = [
              _createTextVNode("P&Ls", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/enterprise/pnls/${workspaceId.value}/${strategyId.value}`]
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_22, [
          _cache[20] || (_cache[20] = _createElementVNode("a", {
            class: "nav-link dropdown-toggle",
            "data-toggle": "dropdown",
            "data-testid": "corporate-nav-business-case"
          }, " Business case ", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_23, [
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_24, [...(_cache[18] || (_cache[18] = [
              _createTextVNode("Templates", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/enterprise/business-case-templates/${workspaceId.value}/${strategyId.value}`]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_25, [...(_cache[19] || (_cache[19] = [
              _createTextVNode("Metrics", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/enterprise/metrics/${workspaceId.value}/${strategyId.value}`]
            ]),
            _createCommentVNode("<a class=\"dropdown-item\" v-sanitizedHref=\"`/#/enterprise/project-phases/${workspaceId}/${strategyId}`\" data-testid=\"corporate-nav-business-case-project-phases\">Phases</a>")
          ])
        ]),
        _createElementVNode("li", _hoisted_26, [
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_27, [...(_cache[21] || (_cache[21] = [
            _createTextVNode("Planning", -1 /* CACHED */)
          ]))])), [
            [_directive_sanitizedHref, `/#/enterprise/planning/${workspaceId.value}/${strategyId.value}`]
          ])
        ]),
        _createCommentVNode("<li class=\"nav-item\">\n        <a class=\"nav-link\" v-sanitizedHref=\"``\">Stakeholders</a>\n    </li>\n    <li class=\"nav-item\">\n        <a class=\"nav-link\" v-sanitizedHref=\"``\">Risks</a>\n    </li>\n    <li class=\"nav-item\">\n        <a class=\"nav-link\" v-sanitizedHref=\"``\">Decisions</a>\n    </li>")
      ]),
      _createElementVNode("ul", _hoisted_28, [
        _createElementVNode("li", _hoisted_29, [
          _cache[27] || (_cache[27] = _createElementVNode("a", {
            class: "nav-link dropdown-toggle",
            "data-toggle": "dropdown",
            "data-testid": "corporate-nav-account"
          }, " Account ", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_30, [
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_31, [...(_cache[22] || (_cache[22] = [
              _createTextVNode("Back to workspace", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/projects/${workspaceId.value}`]
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("a", {
              class: "dropdown-item",
              href: "/#/organizations/users/dashboard",
              "data-testid": "corporate-nav-account-dashboard"
            }, "My dashboard", -1 /* CACHED */)),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_32, [...(_cache[23] || (_cache[23] = [
              _createTextVNode("Manage your account", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/organizations/users/account`]
            ]),
            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_33, [...(_cache[24] || (_cache[24] = [
              _createTextVNode("Sign out", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/organizations/sessions/close`]
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})